import React, { useCallback } from "react";
import { Plus, Trash2 } from "lucide-react";

const normalize = (rows) => (Array.isArray(rows) ? rows : []);

const ReportRowsEditor = ({
  title,
  columns = [],
  rows,
  onChange,
}) => {
  const list = normalize(rows);

  const setRow = useCallback(
    (idx, patch) => {
      const next = list.map((r, i) =>
        i === idx ? { ...(r || {}), ...patch } : r
      );
      onChange(next);
    },
    [list, onChange]
  );

  // const addRow = useCallback(() => {
  //   const nextNo = String((list?.length || 0) + 1);
  //   onChange([...(list || []), { no: nextNo }]);
  // }, [list, onChange]);

  const addRow = useCallback(() => {
    const nextNo = String((list?.length || 0) + 1);
    onChange([
      ...(list || []),
      {
        no: nextNo,
        description: "",
        contractor: "", 
      },
    ]);
  }, [list, onChange]);

  const removeRow = useCallback(
    (idx) => {
      const next = list.filter((_, i) => i !== idx);
      onChange(next.length > 0 ? next : [{ no: "1" }]);
    },
    [list, onChange]
  );

  return (
    <div className="border rounded-md bg-white">
      {/* Header */}
      <div className="flex items-center justify-between px-2 py-1 border-b">
        <div className="text-[11px] font-semibold text-gray-700 uppercase">
          {title}
        </div>
        <button
          type="button"
          onClick={addRow}
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-gray-900 text-white text-[10px] hover:bg-black"
        >
          <Plus className="w-3 h-3" />
          Add
        </button>
      </div>

      {/* Table */}
      <table className="w-full text-[11px] border-collapse">
        <thead className="bg-gray-50 text-gray-600">
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                className="text-left font-medium px-2 py-1 border-b"
                style={{ width: c.width }}
              >
                {c.label}
              </th>
            ))}
            <th className="w-8 border-b"></th>
          </tr>
        </thead>
        <tbody>
          {list.map((row, idx) => (
            <tr key={idx} className="border-b last:border-0">
              {columns.map((c) => (
                <td key={c.key} className="px-2 py-1">
                  <input
                    value={row?.[c.key] ?? ""}
                    onChange={(e) =>
                      setRow(idx, { [c.key]: e.target.value })
                    }
                    className="w-full border rounded px-1.5 py-0.5 text-[11px]"
                  />
                </td>
              ))}
              <td className="px-1 text-right">
                <button
                  type="button"
                  onClick={() => removeRow(idx)}
                  className="p-1 rounded hover:bg-gray-100"
                  title="Remove"
                >
                  <Trash2 className="w-3 h-3 text-red-500" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(ReportRowsEditor);
